import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Grid} from '@material-ui/core'
import {isEmpty,isUndefined,isNull} from 'lodash'
import { getChildKontoLastBokadeByAfid } from 'actions'
import { withStyles } from '@material-ui/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard}) {
    const { authUser} = auth;
    const { LastBokadeChildKontor,DashboardBarnFilterOption} = DashBoard;
    return {
        authUser,LastBokadeChildKontor,DashboardBarnFilterOption
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getChildKontoLastBokadeByAfid: (Afid) => dispatch(getChildKontoLastBokadeByAfid(Afid)),
        dispatch
    };
}
const ColorCode=[
    '#DAA520',
    '#C0C0C0',
    '#b08d57',
    '#ffffff'
]
const styles = props => ({

    scroll: {
        marginRight: '16px',
        marginLeft: '16px',
        paddingTop: '16px',
        paddingRight: '6px',
        '&::-webkit-scrollbar': {
            width: '5px'
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#12484B',
            outline: '1px solid transparent'
        }
    }
  });
class LastVunnen extends Component {
    state={
        LastBokadeKontor:[],
        DashboardBarnFilterOption:isEmpty(this.props.DashboardBarnFilterOption)?[]:this.props.DashboardBarnFilterOption,
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        this.props.getChildKontoLastBokadeByAfid(Afid).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })       
    }
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({done: false,})
                    const Afid = this.props.Afid;
                    this.props.getChildKontoLastBokadeByAfid(Afid).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            30000
        );
      }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }
    formatNumber=(number)=>{
        console.log(number)
        if(number > 1000000){
            return `${(number/1000000).toFixed(0)}M`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return number
        }
    }
    componentDidUpdate=()=>{
        if(!isUndefined(this.props.LastBokadeChildKontor)){
            if(this.props.LastBokadeChildKontor !== this.state.LastBokadeKontor){
                this.setState({
                    LastBokadeKontor:this.props.LastBokadeChildKontor
                })
            }
        }
        if(this.props.DashboardBarnFilterOption !== this.state.DashboardBarnFilterOption && !isEmpty(this.props.DashboardBarnFilterOption))
        {
            const Afid = this.props.Afid;
            this.props.getChildKontoLastBokadeByAfid(Afid).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) /**/
            this.setState({
                DashboardBarnFilterOption:this.props.DashboardBarnFilterOption 
            }) 
        }
    }
    render() {
        const { classes } = this.props;
        return (
           <div className="text-center" style={{ color: 'white' }}>
               <div className="d-flex justify-content-center row" style={{ marginTop: '12px' }}>
               <h2 className="col"  style={{ fontWeight:"500" }}><IntlMessages id="DashBoard.Toplist.Meeting"/></h2>
               </div>
               <div className={classes.scroll} style={{height: this.props.heightB > 1 ? this.props.heightB : 330 ,overflowY:"auto"}}>
                    {
                        this.state.done === false?  
                        <>
                        <div className="row mx-1">
                            <div className="col-12 row mx-1">
                                <Skeleton variant="rectangular" height={40} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                            </div>
                            <div className="col-12 row mx-1">
                                <Skeleton variant="rectangular" height={40} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                            </div>
                            <div className="col-12 row mx-1">
                                <Skeleton variant="rectangular" height={40} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                            </div>
                        </div>
                        </>
                        :
                        isEmpty(this.props.LastBokadeChildKontor)?"":
                        this.props.LastBokadeChildKontor.map((object,index) =>{
                            return (

                                <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                                className="px-2 my-2"
                                // style={{width: '98%'}}
                                >
                                <Grid item>
                                <div className="text-center"
                                style={{ 
                                    backgroundColor: isNull(object.ProfilePicUrl) ? '#075a5f' : '', 
                                    width: '45px', 
                                    height: '45px', 
                                    border: `3px solid ${ColorCode[index]}`, 
                                    borderRadius: '100px',
                                    boxShadow:`5px 5px 8px #00000040`,
                                    backgroundImage: 'url('+object.ProfilePicUrl+')',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center'
                                }}>
                                    <p style={{ fontSize: 20, marginTop:'5px' }}>
                                {
                                    isNull(object.ProfilePicUrl) ?(
                                        `${object.FirstName[0]}${isEmpty(object.LastName)?"":object.LastName[0]}`):''
                                    }
                                </p>
                            </div>
                                </Grid>
                                <Grid item>{object.stad}<br/><small>{
                                    `${object.FirstName} ${isEmpty(object.LastName)?"":object.LastName}`
                                }</small></Grid>
                                <Grid item style={{textAlign:"right"}}>{this.formatNumber(object.total)}st</Grid>
                                </Grid>
                            )
                        })
                    }
                </div>
           </div>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(withStyles(styles)(LastVunnen));